import React from "react";
import PropTypes from "prop-types";

// Modal permettant de donner son avis sur la réponse apportée par le Care Manager à la question du user
const Modal = ({
															showModal,
															setShowModal,
															setReasonOfUnsatisfiedResponse,
															reasonOfUnsatisfiedResponse,
															updateQuestion,
															questionId
															}) => {

const handleRejection = (e) => {
e.preventDefault();
// Update en BDD pour signifier que l'avis est négatif ainsi que le motif écrit par le user
updateQuestion(questionId, 2, reasonOfUnsatisfiedResponse);
setShowModal(false);
};

return (
<>
<div className="content">
<p className="title">Confirmation</p>
<div className="container-modal">
<p className="subtitle">La réponse apportée ne vous a pas satisfait ? <br/>
Expliquez-nous pourquoi : <br/>
<textarea
className="rejectInput" type="text"
onChange={(e) => setReasonOfUnsatisfiedResponse(e.target.value)}
/>
</p>
</div>
<form action="">
<div className="containerButton">
<button className="buttonModalPap orange" onClick={handleRejection}>Oui, je confirme</button>
<button className="buttonModalPap white" onClick={() => setShowModal(false)}>Annuler</button>
</div>
</form>
</div>
<div className="modalBackground" onClick={() => showModal ? setShowModal(false) : null}></div>
</>
);
};

Modal.propTypes = {
showModal: PropTypes.bool,
setShowModal: PropTypes.func,
setReasonOfUnsatisfiedResponse: PropTypes.func,
updateQuestion: PropTypes.func,
questionId: PropTypes.number,
reasonOfUnsatisfiedResponse: PropTypes.string
};

export default Modal;
